import { render, staticRenderFns } from "./modal-login.component.html?vue&type=template&id=0bd0c7dc&scoped=true&external"
import script from "./modal-login.component.ts?vue&type=script&lang=ts&external"
export * from "./modal-login.component.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-login.component.scss?vue&type=style&index=0&id=0bd0c7dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0c7dc",
  null
  
)

export default component.exports